/* eslint-disable */
// AUTO-GENERATED by scripts/generate-antd-compat-icons.mjs — do not edit by hand.
// Regenerate after changing icon-map.txt: `node scripts/generate-antd-compat-icons.mjs`
import { DownCircleFilled as AntdDownCircleFilled } from '@ant-design/icons'
import { CircleChevronDown } from 'lucide-react'

import { createIconDispatcher } from '../dispatch'

export default /*#__PURE__*/ createIconDispatcher(
  'down-circle',
  AntdDownCircleFilled,
  CircleChevronDown,
  'badge'
)
